import React, { useMemo } from 'react';
import { Button, Space } from '@gr-monorepo/common/ui';

import { PlateTemplate } from './PlateTemplate';
import useUserData from 'hooks/useUserData';
import { useGratitudes, monthes } from 'features/gratitudes/useGratitudes';
import ItemsRow from 'features/gratitudes/ItemsRow';
import dayjs from 'dayjs';
import LoaderComponent from 'features/shared/Loader';
import { Error } from './Error';
import { useGratitudesContext } from 'features/gratitudes/GratitudesContext';

export const Portfolio = () => {
  const userData = useUserData();
  const { setVisited, lastVisitedPage } = useGratitudesContext();
  const { loaded, error, store } = useGratitudes(lastVisitedPage);
  const list = useMemo(() => {
    if (!loaded || !store || !store.length) return [];
    const sortedByDesc = [...store].sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
    const lastDiplom = sortedByDesc[0];
    return sortedByDesc.slice(0, 2).filter((el) => el.year === lastDiplom.year && el.month === lastDiplom.month);
  }, [store, loaded]);
  const monthTitle = list.length ? dayjs(list[0].created_at).format('MMMM YYYY') : '';

  if (!loaded && !error) {
    return (
      <PlateTemplate title="Портфолио" link="/gratitude" name="gratitude" dataQaId="gratitude_block">
        <LoaderComponent color={'#825AF7'} />{' '}
      </PlateTemplate>
    );
  }
  if (error) {
    return (
      <PlateTemplate title="Портфолио" link="/gratitude" name="gratitude" dataQaId="gratitude_block">
        <Error />
        <Space size={100} axis="vertical" />
      </PlateTemplate>
    );
  }
  return (
    <PlateTemplate title="Портфолио" link="/gratitude" name="gratitude" dataQaId="gratitude_block">
      <Space size={24} axis="vertical" />
      {list.length ? (
        <>
          <ItemsRow
            title={monthTitle}
            cards={list}
            logPageEvent={() => {
              ///jhk
            }}
          />
          <Space size={24} axis="vertical" />
          <Button data-qa-id="gratitude_block_button">смотреть подробно</Button>
        </>
      ) : null}
    </PlateTemplate>
  );
};
